export const i18nGlossary = {
  action_buttons: {
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    cancel: 'Cancel',
    close: 'Close',
  },
  all: {
    all: 'All',
    all_male: 'All',
    all_female: 'All',
  },
  alarm: {
    alarm: 'alarm',
    alarm_one: 'alarm',
    alarm_other: 'alarms',
  },
  asset: {
    asset: 'asset',
    asset_one: 'asset',
    asset_other: 'assets',
  },
  sensor: {
    sensor: 'sensor',
    sensor_one: 'sensor',
    sensor_other: 'sensors',
  },
  vessel: {
    vessel: 'vessel',
    vessel_one: 'vessel',
    vessel_other: 'vessels',
  },
  category: {
    category: 'category',
    category_one: 'category',
    category_other: 'categories',
  },
  error: {
    title: 'Sorry for the inconvenience',
    message: 'An unexpected error has occurred. Please try again.',
  },
  yes: 'yes',
  no: 'no',
  search: 'Search',
  tryAgain: 'Try again',
  system_name: 'System name',
  screen_name: 'Screen name',
  alarm_id: 'Alarm ID',
  home: 'Home',
  users_and_permissions: 'Users and permissions',
  tags: 'Tags',
  risk_score: 'Risk Score',
  file: { file: 'file', file_one: 'file', file_other: 'files' },
  attachment: {
    attachment: 'attachment',
    attachment_one: 'attachment',
    attachment_other: 'attachments',
  },
  comment: { comment: 'comment', comment_one: 'comment', comment_other: 'comments' },
};
